import { Stack } from 'expo-router';
import React from 'react';

function VaroLineOfCreditLayout() {
  return <Stack />;
}

export default VaroLineOfCreditLayout;
